/**
 * Tomaruba Guest API
 * Tomaruba Guest API
 *
 * OpenAPI spec version: 1.0.0
 * Contact: development@tomaruba.me
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient'

/**
 * The StripeApiKey model module.
 * @module model/StripeApiKey
 * @version 1.0.0
 */
export default class StripeApiKey {
  /**
   * Constructs a new <code>StripeApiKey</code>.
   * @alias module:model/StripeApiKey
   * @class
   */

  constructor() {}

  /**
   * Constructs a <code>StripeApiKey</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/StripeApiKey} obj Optional instance to populate.
   * @return {module:model/StripeApiKey} The populated <code>StripeApiKey</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new StripeApiKey()

      if (data.hasOwnProperty('id')) {
        obj['id'] = ApiClient.convertToType(data['id'], 'Number')
      }
      if (data.hasOwnProperty('hotel_id')) {
        obj['hotel_id'] = ApiClient.convertToType(data['hotel_id'], 'Number')
      }
      if (data.hasOwnProperty('hotel_name')) {
        obj['hotel_name'] = ApiClient.convertToType(data['hotel_name'], 'String')
      }
      if (data.hasOwnProperty('api_key')) {
        obj['api_key'] = ApiClient.convertToType(data['api_key'], 'String')
      }
    }
    return obj
  }

  /**
   * @member {Number} id
   */
  id = undefined
  /**
   * @member {Number} hotel_id
   */
  hotel_id = undefined
  /**
   * @member {String} hotel_name
   */
  hotel_name = undefined
  /**
   * @member {String} api_key
   */
  api_key = undefined
}
